import { urls, request } from '../utils';
import getHeaders from './getHeaders';

export async function pageGroupsListRequest(urlParams = {}) {
  let url = urls.pageGroupsList;

  if (urlParams.page) {
    url = urls.pageGroupsListPsf;
  }

  return request({
    method: 'get',
    url,
    urlParams,
    headers: getHeaders(),
  });
}

export async function pageGroupsItemRequest(urlParams = {}) {
  const url = urls.pageGroupsItem;
  return request({ method: 'get', url, urlParams, headers: getHeaders() });
}

export async function pageGroupsCreateRequest(urlParams, data) {
  return request({
    method: 'post',
    url: urls.pageGroupsCreate,
    data,
    urlParams,
    headers: getHeaders(),
  });
}

export async function pageGroupsUpdateRequest(urlParams, data) {
  return request({
    method: 'put',
    url: urls.pageGroupsUpdate,
    urlParams,
    data,
    headers: getHeaders(),
  });
}

export async function pageGroupsRemoveRequest(urlParams) {
  return request({
    method: 'delete',
    url: urls.pageGroupsRemove,
    urlParams,
    headers: getHeaders(),
  });
}



// WEBPACK FOOTER //
// ./src/services/pageGroups.js